import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/Button";
import Tabs from "../../components/Tabs";

const ROI = (props) => {

  const [ROI, set_ROI] = useState(0);
  const [Expected_return, set_Expected_return] = useState(0);

  const [Expected_percentage, set_Expected_percentage] = useState(0);
  const [withdrawFee, set_withdrawFee] = useState(0);
  const [afterWithdraw, set_afterWithdrawFee] = useState(0);
  


  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  const [isOpen2, setIsOpen2] = useState(false);
  const [selectedOption2, setSelectedOption2] = useState(null);
  const dropdownRef2 = useRef(null);

  const [isOpen3, setIsOpen3] = useState(false);
  const [selectedOption3, setSelectedOption3] = useState(null);
  const dropdownRef3 = useRef(null);

  const [isOpen4, setIsOpen4] = useState(false);
  const [selectedOption4, setSelectedOption4] = useState(null);
  const dropdownRef4 = useRef(null);

  const [investAmount, setInvestAmount] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState("");

  const options = [ 2000, 10000, 20000, 50000,100000,200000];
  const bookOptions = ["Book #1", "Book #2", "Book #3"];
  const durationOptions = ["365 Days"];

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleToggle2 = () => {
    setIsOpen2(!isOpen2);
  };

  const handleToggle3 = () => {
    setIsOpen3(!isOpen3);
  };

  const handleToggle4 = () => {
    setIsOpen4(!isOpen4);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const handleOption2Click = (option) => {
    setSelectedOption2(option);
    setIsOpen2(false);
  };

  const handleOption3Click = (option) => {
    setSelectedOption3(option);
    setIsOpen3(false);
  };

  const handleOption4Click = (option) => {
    setSelectedOption4(option);
    setIsOpen4(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setIsOpen2(false);
      }
      if (
        dropdownRef3.current &&
        !dropdownRef3.current.contains(event.target)
      ) {
        setIsOpen3(false);
      }
      if (
        dropdownRef4.current &&
        !dropdownRef4.current.contains(event.target)
      ) {
        setIsOpen4(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);




  function cal_after_withdraw(_withdraw_Amount) 
  {
    ;
    
  }


  function find_Exp_earn(amount) {

    if(amount ==2000  )
    {
      return amount*0.5/100;
    }
    else if(amount == 10000  )
    {
      return amount*0.6/100;
    }
    else if(amount == 20000  )
    {
      return amount*0.7/100;
    }    
    else if(amount == 50000  )
    {
      return amount*0.8/100;
    }    
    else if(amount == 100000  )
    {
      return amount*0.9/100;
    }   
    else if(amount == 200000  )
    {
      return amount*1/100;
    }
  }
  
  function find_Exp_percentage(amount) {

    if(amount ==2000  )
      {
        return 0.5;
      }
      else if(amount == 10000  )
      {
        return 0.6;
      }
      else if(amount == 20000  )
      {
        return 0.7;
      }    
      else if(amount == 50000  )
      {
        return 0.8;
      }    
      else if(amount == 100000  )
      {
        return 0.9;
      }   
      else if(amount == 200000  )
      {
        return 1;
      }

  }

  function find_afterWithdraw(amount) 
  {

    if ((Number(props.availBalance)/10**18) >= amount) {
      set_afterWithdrawFee(((Number(props.availBalance)/10**18))-amount);
    } else
    {
      set_afterWithdrawFee( 0);

    }
    
  }

  function find_Roi(amount) {
    if (Number(amount) >= 10 && amount <= 400) {
      return  6;
    } else if (amount == 600) {
      return 7 ;
    } else if (amount >= 1200 ) {
      return 9;
  }

  }






  const defaultTab = "Invest";

  const tabData = [
    {
      title: "Invest",
      content: (
        <>
          <div className="tw-rounded-md sm:tw-min-h-[420px] tw-min-h-auto tw-relative">
            <div className="tw-py-4 tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start xs:tw-items-center tw-gap-3">
              <div className="tw-w-full sm:tw-w-7/12">
                <h1 className="tw-m-0 tw-text-white tw-text-xl sm:tw-text-2xl md:tw-text-2xl tw-font-semibold">
                  Boost Your Daily Income With{" "}
                  <span className="hero-title-gradient tw-font-Dots">WLBIZ</span>
                </h1>
              </div>
              <div className="tw-w-full sm:tw-w-5/12 tw-flex tw-justify-end">
                {/* <Button
                  label={"Boost"}
                  rIcons={
                    <img
                      src={require("../../assets/images/boost.png")}
                      className="tw-w-4"
                      alt="boost"
                    />
                  }
                  className={
                    "tw-border tw-bg-transparent tw-text-primary tw-rounded-md  tw-border-primary tw-text-sm xs:tw-text-base tw-py-2 tw-px-3"
                  }
                /> */}
              </div>
            </div>

            <div className="tw-border-t tw-border-b tw-border-white tw-py-4">
              <div className="tw-flex tw-justify-between tw-items-center">
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base tw-font-medium">
                  Per Day Percentage
                </p>
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  {Expected_percentage}%
                </p>
              </div>
              <div className="tw-flex tw-justify-between tw-items-center tw-mt-2">
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base tw-font-medium">
                 Per Day Return
                </p>
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  {Expected_return} WLB 
                </p>
              </div>
            </div>

            {/* <div className="tw-pt-4">
              <label className="tw-text-white  tw-text-sm sm:tw-text-base">
                Invest Amount:(Min:{Number(props.minimum_investment)/10**18}$ - Max:{Number(props.maximum_investment)/10**18}$)
              </label>
              <div className="tw-mt-2">
                <input
                  type="number"
                  className="tw-bg-[#20193A]  right-panel-card  text-white tw-outline-none tw-rounded-lg tw-w-full tw-p-2 sm:tw-p-3 tw-text-sm sm:tw-text-base"
                  value={props.investment}
                  onChange={(e) => {
                    props.setInvestment(e.target.value);
                    set_Expected_return((find_Exp_earn(e.target.value) * e.target.value)/100);

                    set_Expected_percentage(find_Exp_earn(e.target.value));
                  }}
                  placeholder="0"
                  min={props.minimum_investment}
                
                />
              </div>
            </div> */}

            <div className="tw-py-4">
              <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base tw-font-medium">Investment Amount (WLB)</p>
              <div className="tw-mt-2 tw-grid tw-grid-cols-2 xs:tw-grid-cols-3 sm:tw-grid-cols-6 tw-gap-2">
                {options.map((option) => (
                  <button
                    key={option}
                    onClick={() => {setSelectedOption(option);

                      props.setInvestment(option);
                      set_Expected_return(find_Exp_earn(option));
                      // set_ROI(find_Roi(option))
                      set_Expected_percentage(find_Exp_percentage(option));

                    }}
                    className={`tw-py-2 xs:tw-py-3 tw-px-2 xs:tw-px-4 tw-rounded-md tw-border tw-text-sm sm:tw-text-base ${
                      selectedOption === option
                        ? "tw-bg-[#20193A] tw-border-primary tw-text-primary tw-border"
                        : "tw-bg-[#20193A] tw-border-secondary tw-text-white"
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>



            <div className="tw-py-4  tw-mt-12 tw-w-full">
              <Button
                onClick={() => props.Invest()} label={"Invest"}
                className={
                  "tw-w-full tw-text-black tw-rounded-md tw-py-2 sm:tw-py-3"
                }
              />
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Withdraw",
      content: (
        <>
          <div className="tw-rounded-md tw-min-h-[420px] tw-relative">
            <div className="tw-py-4 tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start xs:tw-items-center tw-gap-3">
              <div className="tw-w-full sm:tw-w-7/12">
                <h1 className="tw-m-0 tw-text-white tw-text-xl sm:tw-text-2xl md:tw-text-2xl tw-font-semibold">
                  Withdraw WLB on your Staked amount
                </h1>
              </div>
              {/* <div className="tw-w-full sm:tw-w-5/12 tw-flex tw-justify-end">
                <Button
                  label={"Boost"}
                  rIcons={
                    <img
                      src={require("../../assets/images/boost.png")}
                      className="tw-w-4"
                      alt="boost"
                    />
                  }
                  className={
                    "tw-border tw-bg-transparent  tw-text-primary tw-rounded-md tw-border-primary tw-text-sm xs:tw-text-base tw-py-2 tw-px-3"
                  }
                />
              </div> */}
            </div>

            <div className="tw-border-t tw-border-b tw-border-white tw-py-4">
              <div className="tw-flex tw-justify-between tw-items-center tw-mb-3">
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  Balance After Withdraw
                </p>
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  {Number(afterWithdraw).toFixed(3)} WLB
                </p>
              </div>
              <div className="tw-flex tw-justify-between tw-items-center tw-mb-3">
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  Curr WLB Price
                </p>
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  {Number(props.exorUsdPrice).toFixed(9)} WLB
                </p>
              </div>
              <div className="tw-flex tw-justify-between tw-items-center tw-mb-3">
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  Expected WLB
                </p>
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  {Number(withdrawFee).toFixed(3)} WLB
                </p>
              </div>
              {/* <div className="tw-flex tw-justify-between tw-items-center">
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  Total Withdraw
                </p>
                <p className="tw-m-0 tw-text-white tw-text-sm sm:tw-text-base">
                  
                  {Number(props.total_withdraw_reward)/10**18}
                </p>
              </div> */}
            </div>

            <div className="tw-pt-4">
              <label className="tw-text-white tw-text-sm sm:tw-text-base">
                Withdraw Amount (Min : 10 WLB)
              </label>
              <div className="tw-mt-2">
                <input
                  type="number"
                  className="tw-bg-[#20193A] right-panel-card text-white tw-outline-none tw-rounded-lg tw-w-full tw-p-2 sm:tw-p-3 tw-text-sm sm:tw-text-base"
                      placeholder="Write Amount in USD" 
                      value={props.withdraw_Amount}
                      onChange={(e) => {
                        props.set_withdraw_Amount(e.target.value);
                        find_afterWithdraw(Number(e.target.value));
                        set_withdrawFee(Number(e.target.value)/Number(props.exorUsdPrice))

                      }}
                />
              </div>
            </div>

            <div className="tw-py-4 tw-absolute tw-bottom-0 tw-w-full">
              <Button
              onClick={() => props.WithdrawReward()}
                label={"Withdraw"}
                className={
                  "tw-w-full tw-text-white tw-rounded-md tw-py-2 sm:tw-py-3"
                }
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div className="tw-bg-center tw-relative tw-bg-cover tw-w-full tw-h-auto">
      <div className="tw-max-w-4xl tw-mx-auto">
        <Tabs tabs={tabData} defaultTab={defaultTab} />
      </div>
    </div>
  );
};

export default ROI;
